// Story 11.8 — the admin user detail read (Screen 21).
//
// ONE payload feeds all three cards (Account / Access / Calibration). The
// calibration card is an EQUIVALENT MOUNT of 11.3's block, not a second request:
// closing seam-86-admin-card-mount without adding a per-card fetch is the point.

import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { AdminUserDetail } from "@/hooks/queries/admin-users-types";

export const ADMIN_USER_QUERY_KEY = "admin-user";

export function adminUserQueryKey(userId: string) {
  return [ADMIN_USER_QUERY_KEY, userId] as const;
}

export function adminUserPath(userId: string): string {
  return `/admin/users/${encodeURIComponent(userId)}`;
}

export function useAdminUserDetail(userId: string) {
  return useQuery({
    queryKey: adminUserQueryKey(userId),
    queryFn: () => apiFetch<AdminUserDetail>(adminUserPath(userId)),
    retry: false,
  });
}
